import React, { Fragment, useState } from 'react'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'
import navigate from 'utils/navigate'
import { useSignOutHandler } from 'auth/handleSignOut'
import {
  CLICK_ACCOUNT_MENU_EVENT,
  CLICK_SUBSCRIPTION_ACCOUNT_MENU_EVENT,
  CLICK_HELP_ACCOUNT_MENU_EVENT,
  CLICK_REQUEST_FEATURE_ACCOUNT_MENU_EVENT,
} from 'amplitude/events'
import useLogEvent from 'amplitude/useLogEvent'
import get from 'lodash/get'
import useCurrentUser from 'auth/useCurrentUser'
import { useHasSubscriberPrivilege } from 'utils/useUserType'
import useFreeTrialExperiment from 'experiments/useFreeTrialExperiment'

const adminOrOperator = userType =>
  userType === 'admin' || userType === 'operator'

export const handleMenu = ({ logEvent, setter }) => event => {
  logEvent && logEvent(CLICK_ACCOUNT_MENU_EVENT)
  setter(event.currentTarget)
}
export const handleClose = setter => () => setter(null)

export const goTo = (destination, callback) => () => {
  callback && callback()
  navigate(destination)
}

const AccountMenu = () => {
  const handleSignOut = useSignOutHandler()
  const [anchorEl, setAnchorEl] = useState(null)

  const hasSubscriberPrivilege = useHasSubscriberPrivilege()
  const [{ currentUser }] = useCurrentUser()
  const userType = get(currentUser, 'userType')
  const hasPausedSubscription = get(currentUser, 'hasPausedSubscription')

  const logEvent = useLogEvent()

  const { hasFreeTrial } = useFreeTrialExperiment()

  return (
    <Fragment>
      <IconButton
        aria-label="Account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu({ setter: setAnchorEl, logEvent })}
        color="secondary"
      >
        <AccountCircle style={{ fontSize: 30 }} />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose(setAnchorEl)}
      >
        {adminOrOperator(userType) && (
          <MenuItem onClick={goTo('/admin')}>CMS</MenuItem>
        )}
        <MenuItem onClick={goTo('/account/edit-profile')}>
          Edit Profile
        </MenuItem>
        {(hasSubscriberPrivilege || hasPausedSubscription) && (
          <MenuItem
            onClick={goTo('/subscription', () =>
              logEvent(CLICK_SUBSCRIPTION_ACCOUNT_MENU_EVENT),
            )}
          >
            Subscription
          </MenuItem>
        )}
        <MenuItem onClick={goTo('/saved-guides')}>Saved Guides</MenuItem>
        <MenuItem
          onClick={goTo(
            hasFreeTrial
              ? process.env.REACT_APP_HELPCENTER_HOME_V2
              : process.env.REACT_APP_HELPCENTER_HOME,
            () => {
              logEvent(CLICK_HELP_ACCOUNT_MENU_EVENT)
            },
          )}
        >
          Help
        </MenuItem>
        <MenuItem
          onClick={goTo(
            hasFreeTrial
              ? process.env.REACT_APP_HELPCENTER_NEW_TICKET_V2
              : process.env.REACT_APP_HELPCENTER_NEW_TICKET,
            () => {
              logEvent(CLICK_REQUEST_FEATURE_ACCOUNT_MENU_EVENT)
            },
          )}
        >
          Request a feature
        </MenuItem>
        <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
      </Menu>
    </Fragment>
  )
}

export default AccountMenu
